/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_7_ObjectInputs */

const en_privacy_section_7_object = /** @type {(inputs: Privacy_Section_7_ObjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right to object`)
};

const lv_privacy_section_7_object = /** @type {(inputs: Privacy_Section_7_ObjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiesības iebilst`)
};

/**
* | output |
* | --- |
* | "Right to object" |
*
* @param {Privacy_Section_7_ObjectInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_7_object = /** @type {((inputs?: Privacy_Section_7_ObjectInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_7_ObjectInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_7_object(inputs)
	return en_privacy_section_7_object(inputs)
});